import { render, staticRenderFns } from "./DeviceTypeInfo.vue?vue&type=template&id=35362aff&scoped=true&"
import script from "./DeviceTypeInfo.vue?vue&type=script&lang=js&"
export * from "./DeviceTypeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35362aff",
  null
  
)

export default component.exports